import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_QR_CODE_LINK_TITLE = 'UPDATE_QR_CODE_LINK_TITLE' as const;

export const updateQrCodeLinkTitle = (title: string) => ({
  data: { title },
  type: UPDATE_QR_CODE_LINK_TITLE,
});

export type UpdateQrCodeLinkTitleResponseAction = DataAction<typeof UPDATE_QR_CODE_LINK_TITLE, { title: string }>;
